
import React from "react";
import { SzTable } from "@suezenv/react-theme-components";
import './eventTable.scss'

const EventTable: any = (props: any) => {

    const {columns=[], data=[]} = props;

    return (
        <SzTable
            keyField="id"
            columns={columns}
            data={data}
            className="table-striped"
        />
    );
};

export default EventTable;
